import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { getMainDefinition } from '@apollo/client/utilities';
import { possibleTypes } from '@src/graphql/introspection.json';
import { Endpoint } from '@src/config/enums/endpoints.enum';
import { typePolicies } from './cache/typepolicies';
import { graphQLWsLink } from './links/wslink';
import { uploadLink } from './links/uploadLink';
import { authLink } from './links/authLink';
import { errorLink } from './links/errorLink';
import { authMiddlewareLink } from './links/authMiddlewareLink';
import { sentryLink } from './links/sentryLink';
import { publicEndpointLink } from './links/publicEndpointLink';

const httpLink = ApolloLink.from([authMiddlewareLink, sentryLink, authLink, errorLink, uploadLink]);

const directionalLink = new RetryLink().split(
  operation => operation.getContext().clientName === Endpoint.PUBLIC,
  publicEndpointLink,
  httpLink,
);

export default new ApolloClient({
  cache: new InMemoryCache({
    possibleTypes: possibleTypes,
    typePolicies: typePolicies,
  }),
  link: ApolloLink.split(
    operation => {
      const definition = getMainDefinition(operation.query);

      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    graphQLWsLink,
    directionalLink,
  ),
});
